import { GET_JOB_PACKS, GET_PROFILE } from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { push } from "connected-react-router";
export const getJobPacks = (stat = false, year = false, month = false) => {
    return dispatch => {
        dispatch({ type: GET_JOB_PACKS.REQUEST });

        try {
            if (stat && year && month) {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/jobpacks/${stat}/${year}/${month}/`)
                            .on("value", snapshot => {
                                dispatch({
                                    type: GET_JOB_PACKS.SUCCESS,
                                    payload: snapshot.val()
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACKS.FAIL });
                    }
                });
            } else {
                dispatch({ type: GET_JOB_PACKS.FAIL });
            }
        } catch {
            dispatch({ type: GET_JOB_PACKS.FAIL });
        }
    };
};
export const redirectTo = link => {
    return dispatch => {
        dispatch(push(link));
    };
};
export const getProfile = () => {
    return dispatch => {
        dispatch({ type: GET_PROFILE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/${user.uid}`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_PROFILE.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_PROFILE.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_PROFILE.FAIL });
        }
    };
};
